import {AbstractControl, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

export function datetimeNotInFutureValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const date = control.value as Date;
    if (date && date > new Date()) {
      return {"DatetimeNotInFuture": true};
    }
    return null;
  }
}
